import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StyledCurrency = ({ value, symbolWeight = 400, valueWeight = 400, fontSize, // 👈 NEW: overall size
symbolSize, // 👈 NEW: symbol specific size
symbolColor = "#A1A1AA", valueColor, className = 'valueclass', style = {}, titleTooltip }) => {
    if (value === null || value === undefined) {
        return _jsx("span", { className: className, style: style, children: "-" });
    }
    const stringValue = String(value);
    const currencySymbols = ['$', '€', '£', '¥', '₹'];
    const firstChar = stringValue.charAt(0);
    const hasCurrencySymbol = currencySymbols.includes(firstChar);
    const lastChar = stringValue.charAt(stringValue.length - 1);
    const hasPercentSymbol = lastChar === '%';
    // Container/value styles
    const containerStyle = {
        ...style,
        fontWeight: valueWeight,
        ...(fontSize && { fontSize }),
        ...(valueColor && { color: valueColor }),
    };
    if (hasCurrencySymbol) {
        const symbol = firstChar;
        const number = stringValue.slice(1);
        // Symbol styles
        const symbolStyle = {
            fontWeight: symbolWeight,
            fontSize: symbolSize || fontSize, // symbol size or inherit overall
            ...(symbolColor && { color: symbolColor }),
            paddingRight: "2px",
        };
        return (_jsxs("span", { className: className, style: containerStyle, title: titleTooltip, children: [_jsx("span", { style: symbolStyle, children: symbol }), number] }));
    }
    if (hasPercentSymbol) {
        const symbol = lastChar;
        const number = stringValue.slice(0, -1);
        // Symbol styles
        const symbolStyle = {
            fontWeight: symbolWeight,
            fontSize: symbolSize || fontSize,
            ...(symbolColor && { color: symbolColor }),
            paddingLeft: "2px",
        };
        return (_jsxs("span", { className: className, style: containerStyle, title: titleTooltip, children: [number, _jsx("span", { style: symbolStyle, children: symbol })] }));
    }
    // No currency or percent symbol
    return (_jsx("span", { className: className, style: containerStyle, title: titleTooltip, children: stringValue }));
};
